import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { cn } from '@lyearn/style';
import { Typography, TypographyVariants } from '@lyearn/ui';
import { ContentCardTypeEnum } from '@/modules/content/config/cards';

import { useBaseCard } from '../Provider';
import { BaseCardComposition } from '../types';

const Label: BaseCardComposition['Label'] = React.memo((props) => {
  const baseCardProps = useBaseCard();
  const { label, labelNode, cardType } = baseCardProps;
  const { isMobile } = useScreen();

  if (!label && !labelNode) {
    return null;
  }

  const isMiniCard = cardType === ContentCardTypeEnum.Mini;
  let variant: TypographyVariants;
  if (isMiniCard) {
    if (isMobile) {
      variant = 'body-short-03';
    }
    variant = 'label-03';
  } else {
    variant = 'label-caps';
  }

  return (
    labelNode ?? (
      <Typography
        color="text-text-secondary"
        numberOfLines={1}
        variant={variant}
        {...props}
        className={cn(
          'flex-shrink-1 align-center',
          props.className,
          isMiniCard ? '' : 'uppercase',
        )}>
        {label}
      </Typography>
    )
  );
});

export default Label;
